import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Nabvar from '../Components/Navbar/Navbar';
import Demo from '../Pages/Demo/Demo';

export default function IndexLayout() {
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const mesaToken = params.get('mesaToken');
        if (mesaToken) {
            navigate(`/menu?mesaToken=${encodeURIComponent(mesaToken)}`, { replace: true });
        }
    }, [navigate]);

    return (
        <div className='section-bg-color'>
            <Nabvar />
            <div className='espaciobg'></div>
            <Demo />
        </div>
    );
}
